import React, { forwardRef } from 'react';
import NoteEditor from './NoteEditor';
import MarketCoverImage from './MarketCoverImage';
import { t } from '../i18n';

function MarketListingForm({ listing = {}, onSave, onSaved, onCancel, publishing = false }, ref) {
  return <NoteEditor
    ref={ref}
    initialNote={{ ...listing, noteTitle: listing.title || listing.noteTitle || '' }}
    mode={publishing ? 'publish' : 'edit'} destination="market"
    onCancel={onCancel}
    onSaved={onSaved}
    currentCoverPreview={listing.coverUrl ? <MarketCoverImage listingId={listing.id} hasCover coverVersion={listing.coverVersion} alt={t('market.form.coverPreview')} className="cover-preview-image" /> : null}
    onSave={async ({ noteTitle, isEnabled, ...payload }) => onSave({ ...payload, title: noteTitle })}
  />;
}

export default forwardRef(MarketListingForm);
